class ModuleLoader {

  constructor(app) {
    this.app = app;
    this.path = app.lookup('vocento.config.nibara').path;
    if (this.path === undefined) {
      throw 'nibara path config is empty';
    }
    this.libPath = app.lookup('vocento.config.nibara').libPath;
    if (this.libPath === undefined) {
      throw 'nibara libPath config is empty';
    }
    this.modules = {};
  }

  initialize($elm = null) {
    const Logger = nibara.logger;
    Logger.debug('ModuleLoader: Initialize');

    /**
     * InView elements
     */
    let nibaraInviewElms = [];
    if ($elm !== null) {
      nibaraInviewElms = $elm.find('.nibara-element-inview');
    } else {
      nibaraInviewElms = Voonto.$('.nibara-element-inview');
    }

    if (nibaraInviewElms) {
      this.app.load(this.libPath + 'jquery-inview-tea3/jquery.inview.min.js').then(() => {
        nibaraInviewElms.each((key, elm) => {
          let $elm = Voonto.$(elm);
          let offset = $elm.data('offset') || 0;
          let theObj = this;

          /** switch mode LIVE (ON) */
          if ($elm.data('nibara-inview-mode') === 'live') {
            $elm.on('inview', (event, isInView, visiblePartX, visiblePartY) => {

              /** wakeup only once */
              if ($elm.data('awakened') !== true) {
                this.callModuleMethod($elm, 'wakeUp');
                $elm.data('awakened', true);
              }
              /** top view event */
              if (isInView && visiblePartY === 'top') {
                Logger.debug('[inview live] Visible TOP: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);

                if (window.nibara.isBack && $elm.data('section') !== window.nibara.lastSectionView)  {
                    let promise = new Promise(function(resolve, reject) {

                        let moduleName = $elm.data('nibara-module');
                        if (moduleName) {
                          theObj.callModuleMethod($elm, 'visibleTop');
                          resolve();
                        } else {
                          reject();
                        }

                    });
                    promise.then((result) => {
                        Logger.debug('[inview live] Visible TOP: Promesa ok para la sección '+ $elm.data('section'));
                    }).catch((error) => {
                        Logger.debug('[inview live] Visible TOP: Promesa falló para la sección '+ $elm.data('section') + '.Error: '+error.message);
                    });
                } else {
                    this.callModuleMethod($elm, 'visibleTop');
                }
              }
              /** bottom view event */
              if (isInView && visiblePartY === 'bottom') {
                Logger.debug('[inview live] Visible BOTTOM: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
                if (window.nibara.isBack && $elm.data('section') !== window.nibara.lastSectionView)  {
                    let promise = new Promise(function(resolve,reject) {
                        let moduleName = $elm.data('nibara-module');
                        if (moduleName) {
                            theObj.callModuleMethod($elm, 'visibleBottom');
                            resolve();
                        } else {
                            reject();
                        }

                    });
                    promise.then((result) => {
                        Logger.debug('[inview live] Visible BOTTOM: Promesa ok para la sección '+ $elm.data('section'));
                    }).catch((error) => {
                        Logger.debug('[inview live] Visible BOTTOM: Promesa falló para la sección '+ $elm.data('section') + '.Error: '+error.message);
                    });
                } else {
                    this.callModuleMethod($elm, 'visibleBottom');
                }
              }
              /** entire view event */
              if (isInView && visiblePartY === 'both') {
                //Logger.debug('[inview live] Visible ENTIRE: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
                this.callModuleMethod($elm, 'visibleEntire');
              }
              /** out view event */
              if (!isInView) {
                //Logger.debug('[inview live] NOT Visible: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
                this.callModuleMethod($elm, 'notVisible');
              }
            });

            /** switch mode ONE */
          } else {
            $elm.one('inview', (event, isInView) => {
              if (isInView) {
                //Logger.debug('[inview one] Visible: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
                this.callModuleMethod($elm, 'wakeUp');
              }
            });
          }
        })
      });
    }

    /**
     * NO InView elements
     */
    let nibaraElms = [];
    if ($elm !== null) {
      nibaraElms = $elm.find('.nibara-element');
    } else {
      nibaraElms = Voonto.$('.nibara-element');
    }

    if (nibaraElms) {
      nibaraElms.each((key, elm) => {
        let $elm = Voonto.$(elm);
        this.callModuleMethod($elm, 'wakeUp');
      })
    }
  }

  /**
   * Call to module and exec method
   * @param $elm
   * @param method
   */
  callModuleMethod($elm, method) {
    const Logger = nibara.logger;
    let moduleName = $elm.data('nibara-module');
    if (moduleName) {
      if (this.modules[moduleName]) {
        let module = this.modules[moduleName];
        if (typeof module[method] === 'function') {
          module[method]($elm);
        } else {
          Logger.warn(`Method "${method}" not found in module "${moduleName}"`);
        }
      } else {
        let elementFilePath = this.path + '/' + moduleName + '-module.js';
        elementFilePath = window.nibara.nTools.getStaticNode(elementFilePath);
        this.app.require([elementFilePath], (module) => {
          this.modules[moduleName] = module;
          if (typeof module[method] === 'function') {
            module[method]($elm);
          } else {
            Logger.warn(`Method "${method}" not found in module "${elementFilePath}"`);
          }
        });
      }
    }
  }
}

export default ModuleLoader;



// WEBPACK FOOTER //
// ./src/ModuleLoader.js